<div class="container">
    <div>
        <h2 *ngIf="!isEdit">Datenformat anlegen</h2>
        <h2 *ngIf="isEdit">Datenformat bearbeiten</h2>
        <form [formGroup]="form" *ngIf="form">
            <div class="auto-min">
                <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="name" class="full-width" />
                    <mat-hint>Name gemäß DIN SPEC Open CDE</mat-hint>
                    <mat-error *ngIf="name.hasError('required')">Bitte geben Sie einen Namen an</mat-error>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Status</mat-label>
                    <mat-select formControlName="active" class="full-width">
                        <mat-option [value]="true">Aktiv</mat-option>
                        <mat-option [value]="false">Inaktiv</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <app-text-editor [(editorText)]="form.controls.description.value"
                (editorTextChange)="onDescriptionTextChange($event)" class="full-width"></app-text-editor>
        </form>
        <h3>Schema</h3>
        <table mat-table [dataSource]="schemas" class="full-width data-table">
            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let element">{{ element.name }}</td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="version">
                <th mat-header-cell *matHeaderCellDef>Version</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.version }}
                </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="subSchema">
                <th mat-header-cell *matHeaderCellDef>Subschema</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.subSchema }}
                </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element; let i = index">
                    <div class="flex">
                        <button mat-icon-button (click)="editSchema(i)">
                            <i class="fa fa-pencil"></i>
                        </button>
                        <button mat-icon-button (click)="deleteSchema(i)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="['name', 'version', 'subSchema', 'actions']"></tr>
            <tr mat-row *matRowDef="
                    let row;
                    columns: ['name', 'version', 'subSchema', 'actions']
                "></tr>
        </table>
        <div *ngIf="schemas.length === 0" class="text-center">
            <i>Keine Schemas angelegt</i>
        </div>
        <button matButton="elevated" color="accent" (click)="toggleAddSchemaForm()">
            Schema hinzufügen
        </button>
        <ng-container *ngIf="showAddSchemaForm">
            <form [formGroup]="addSchemaFormGroup" class="add-form" (submit)="handleAddSchemaSubmit()">
                <input type="hidden" name="index" [value]="addSchemaFormGroup.controls.index.value" />
                <input type="hidden" name="id" [value]="addSchemaFormGroup.controls.id.value" />
                <div class="auto-min">
                    <mat-form-field>
                        <mat-label>Name</mat-label>
                        <input matInput formControlName="name" class="full-width" />
                        <mat-hint>z.B. gemäß DIN SPEC Open CDE</mat-hint>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Version</mat-label>
                        <input matInput formControlName="version" class="full-width" />
                        <mat-hint>z.B. gemäß DIN SPEC Open CDE</mat-hint>
                    </mat-form-field>
                </div>
                <div class="flex-container">
                    <mat-form-field class="full-width">
                        <mat-label>Subschema</mat-label>
                        <input matInput formControlName="subSchema" class="full-width" />
                        <mat-hint>z.B. gemäß DIN SPEC Open CDE</mat-hint>
                    </mat-form-field>
                    <button matButton="elevated" class="green-confirm" type="submit">
                        Hinzufügen
                    </button>
                    <button matButton="elevated" color="warn" (click)="toggleAddSchemaForm()" type="reset">
                        Abbrechen
                    </button>
                </div>
            </form>
        </ng-container>
        <h3>Dateiformate</h3>
        <table mat-table [dataSource]="fileFormats" class="full-width data-table">
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let element">{{ element.name }}</td>
            </ng-container>

            <ng-container matColumnDef="mimeType">
                <th mat-header-cell *matHeaderCellDef>MIME-Typ</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.mimeType }}
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element; let i = index">
                    <div class="flex">
                        <button mat-icon-button (click)="editFileFormat(i)">
                            <i class="fa fa-pencil"></i>
                        </button>
                        <button mat-icon-button (click)="deleteFileFormat(i)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="['name', 'mimeType', 'actions']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['name', 'mimeType', 'actions']"></tr>
        </table>
        <div *ngIf="fileFormats.length === 0" class="text-center">
            <i>Keine Dateiformate angelegt</i>
        </div>
        <button matButton="elevated" color="accent" (click)="toggleAddFileFormatForm()">
            Dateiformat hinzufügen
        </button>
        <ng-container *ngIf="showAddFileFormatForm">
            <form [formGroup]="addFileFormatFromGroup" class="add-form flex-container" (submit)="handleAddFileFormatSubmit()">
                <input type="hidden" name="index" [value]="addFileFormatFromGroup.controls.index.value" />
                <mat-form-field class="full-width">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="name" class="full-width" />
                    <mat-hint>Name des Dateiformats</mat-hint>
                </mat-form-field>
                <mat-form-field class="full-width">
                    <mat-label>MIME-Typ</mat-label>
                    <input matInput formControlName="mimeType" class="full-width" />
                    <mat-hint>z.B. gemäß DIN SPEC Open CDE</mat-hint>
                </mat-form-field>
                <button matButton="elevated" class="green-confirm" type="submit">
                    Speichern
                </button>
                <button matButton="elevated" color="warn" (click)="toggleAddFileFormatForm()" type="reset">
                    Abbrechen
                </button>
            </form>
        </ng-container>
        <div class="button-row flex-container">
            <button matButton="elevated" class="green-confirm" (click)="save()">
                Speichern
            </button>
            <button matButton="elevated" color="warn" (click)="handleCancelClick()">Abbrechen</button>
        </div>
    </div>
</div>